import { render, staticRenderFns } from "./PromoPointer.vue?vue&type=template&id=4266eff7&scoped=true"
import script from "./PromoPointer.vue?vue&type=script&lang=js"
export * from "./PromoPointer.vue?vue&type=script&lang=js"
import style0 from "./PromoPointer.vue?vue&type=style&index=0&id=4266eff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4266eff7",
  null
  
)

export default component.exports